class FacetFiltersForm extends HTMLElement {
    constructor() {
        (super(),
            (this.onActiveFilterClick = this.onActiveFilterClick.bind(this)),
            (this.debouncedOnSubmit = debounce((e) => {
                this.onSubmitHandler(e);
            }, 500)));
        this.querySelector("form").addEventListener(
            "input",
            this.debouncedOnSubmit.bind(this),
        );
        var e = this.querySelector("#FacetsWrapperDesktop"),
            e =
                (e && e.addEventListener("keyup", onKeyUpEscape),
                    this.querySelector(".facets__button-show"));
        (e &&
            ((e.onclick = () => {
                (this.querySelector(".facets__wrapper").classList.add("active"),
                    this.closest(".collection-wrapper")
                        .querySelector(".facets-container")
                        .classList.add("active"),
                    this.closest(".collection-wrapper")
                        .querySelector(".products-grid__overlay")
                        .classList.add("active"),
                    document.body.classList.add("overflow-hidden"),
                    this.querySelectorAll(
                        ".facets__wrapper details, .facets__wrapper a, .facets__wrapper input, .facets__wrapper button ",
                    ).forEach((e) => {
                        e.removeAttribute("tabindex");
                    }));
            }),
                (this.querySelector(".facets__close").onclick = () => {
                    (this.querySelector(".facets__wrapper").classList.remove("active"),
                        this.closest(".collection-wrapper")
                            .querySelector(".facets-container")
                            .classList.remove("active"),
                        this.closest(".collection-wrapper")
                            .querySelector(".products-grid__overlay")
                            .classList.remove("active"),
                        document.body.classList.remove("overflow-hidden"),
                        this.querySelectorAll(
                            ".facets__wrapper details, .facets__wrapper a, .facets__wrapper input, .facets__wrapper button ",
                        ).forEach((e) => {
                            e.setAttribute("tabindex", "-1");
                        }));
                }),
                window.addEventListener("keyup", (e) => {
                    "ESCAPE" === e.code.toUpperCase() &&
                        (this.querySelector(".facets__wrapper").classList.remove("active"),
                            this.closest(".collection-wrapper")
                                .querySelector(".facets-container")
                                .classList.remove("active"),
                            this.closest(".collection-wrapper")
                                .querySelector(".products-grid__overlay")
                                .classList.remove("active"),
                            document.body.classList.remove("overflow-hidden"),
                            this.querySelectorAll(
                                ".facets__wrapper details, .facets__wrapper a, .facets__wrapper input, .facets__wrapper button ",
                            ).forEach((e) => {
                                e.setAttribute("tabindex", "-1");
                            }));
                })),
            document.addEventListener("click", (e) => {
                var t = document.querySelectorAll(
                    ".facets__wrapper--horizontal .facets__disclosure",
                ),
                    r = e.target.closest(".facets__disclosure[open]"),
                    a = document.querySelector(".facets__wrapper--horizontal_united"),
                    c = e.target.closest(".facets__wrapper--horizontal_united"),
                    l = e.target.closest(".loading-overlay");
                (a &&
                    a != c &&
                    !e.target.closest(".facets__reset ") &&
                    document.querySelector(".facets__button-show") !=
                    e.target.closest(".facets__button-show") &&
                    document.querySelector(".loading-overlay") != l &&
                    (a.classList.remove("active"),
                        e.target.closest(".products-grid__overlay") &&
                        e.target
                            .closest(".products-grid__overlay")
                            .classList.remove("active"),
                        document.body.classList.remove("overflow-hidden")),
                    !r &&
                    t &&
                    t.forEach((e) => {
                        e.removeAttribute("open");
                    }));
            }));
    }
    static calcMinHeight = () => {
        var e = document.querySelector(".facets__top"),
            t = document.querySelector(".facets__sort-wrapper"),
            r = document.querySelector(".collection-wrapper");
        e &&
            t &&
            r &&
            (r.style.gridTemplateRows =
                t.getBoundingClientRect().height > e.getBoundingClientRect().height
                    ? t.getBoundingClientRect().height + "px auto 1fr"
                    : e.getBoundingClientRect().height + "px auto 1fr");
    };
    static setListeners() {
        window.addEventListener("popstate", (e) => {
            e = e.state ? e.state.searchParams : FacetFiltersForm.searchParamsInitial;
            e !== FacetFiltersForm.searchParamsPrev &&
                FacetFiltersForm.renderPage(e, null, !1);
        });
    }
    static toggleActiveFacets(t = !0) {
        document.querySelectorAll(".js-facet-remove").forEach((e) => {
            e.classList.toggle("disabled", t);
        });
    }
    static renderPage(r, a, e = !0) {
        FacetFiltersForm.searchParamsPrev = r;
        var t = FacetFiltersForm.getSections(),
            c = document.getElementById("ProductCount"),
            l = document.getElementById("ProductCountDesktop"),
            s = document.querySelector(".button--results");
        (document
            .getElementById("ProductGridContainer")
            .querySelector(".collection")
            .classList.add("loading"),
            c && c.classList.add("loading"),
            l
                ? l.classList.add("loading")
                : (document.querySelector(".loading-overlay").style.top = "0"),
            s && s.classList.add("loading"),
            t.forEach((e) => {
                let t = `${window.location.pathname}?section_id=${e.section}&` + r;
                e = (e) => e.url === t;
                FacetFiltersForm.filterData.some(e)
                    ? FacetFiltersForm.renderSectionFromCache(e, a)
                    : FacetFiltersForm.renderSectionFromFetch(t, a);
            }),
            e && FacetFiltersForm.updateURLHash(r));
    }
    static renderSectionFromFetch(t, r) {
        fetch(t)
            .then((e) => e.text())
            .then((e) => {
                ((FacetFiltersForm.filterData = [
                    ...FacetFiltersForm.filterData,
                    { html: e, url: t },
                ]),
                    FacetFiltersForm.renderFilters(e, r),
                    FacetFiltersForm.renderProductGridContainer(e),
                    FacetFiltersForm.renderProductCount(e));
            });
    }
    static renderSectionFromCache(e, t) {
        e = FacetFiltersForm.filterData.find(e).html;
        (FacetFiltersForm.renderFilters(e, t),
            FacetFiltersForm.renderProductGridContainer(e),
            FacetFiltersForm.renderProductCount(e));
    }
    static renderProductGridContainer(e) {
        ((document.getElementById("ProductGridContainer").innerHTML =
            new DOMParser()
                .parseFromString(e, "text/html")
                .getElementById("ProductGridContainer").innerHTML),
            (document.querySelector(".js-load-more") ||
                document.querySelector(".js-infinite-scroll")) &&
            loadMore(),
            colorSwatches());
    }
    static renderProductCount(e) {
        var e = new DOMParser()
            .parseFromString(e, "text/html")
            .getElementById("ProductCount").innerHTML,
            t = document.getElementById("ProductCount"),
            r = document.getElementById("ProductCountDesktop"),
            a = document.querySelector(".button--results");
        ((t.innerHTML = e),
            t.classList.remove("loading"),
            a && a.classList.remove("loading"),
            r && ((r.innerHTML = e), r.classList.remove("loading")),
            document
                .querySelectorAll(
                    ".facets__wrapper details, .facets__wrapper a, .facets__wrapper input, .facets__wrapper button ",
                )
                .forEach((e) => {
                    e.removeAttribute("tabindex");
                }));
    }
    static renderFilters(e, r) {
        var e = new DOMParser().parseFromString(e, "text/html"),
            t = e.querySelectorAll(
                "#FacetFiltersForm .js-filter, #FacetFiltersPillsForm .js-filter, #FacetFiltersFormMobile .js-filter",
            );
        let a = (e) => {
            var t = r ? r.target.closest(".js-filter") : void 0;
            return !!t && e.dataset.index === t.dataset.index;
        };
        var c = Array.from(t).filter((e) => !a(e)),
            t = Array.from(t).find(a);
        (c.forEach((e) => {
            document.querySelector(
                `.js-filter[data-index="${e.dataset.index}"]`,
            ).innerHTML = e.innerHTML;
        }),
            FacetFiltersForm.renderActiveFacets(e),
            t && FacetFiltersForm.renderCounts(t, r.target.closest(".js-filter")));
    }
    static renderActiveFacets(r) {
        ([".active-facets-desktop"].forEach((e) => {
            var t = r.querySelector(e);
            t &&
                ((document.querySelector(e).innerHTML = t.innerHTML),
                    FacetFiltersForm.calcMinHeight());
        }),
            FacetFiltersForm.toggleActiveFacets(!1));
    }
    static renderCounts(e, t) {
        var r = t.querySelector(".facets__selected"),
            a = e.querySelector(".facets__selected"),
            c = t.querySelector(".facets__summary"),
            l = e.querySelector(".facets__summary");
        (a &&
            r &&
            (t.querySelector(".facets__selected").outerHTML =
                e.querySelector(".facets__selected").outerHTML),
            c &&
            l &&
            (t.querySelector(".facets__summary").outerHTML =
                e.querySelector(".facets__summary").outerHTML));
    }
    static updateURLHash(e) {
        history.pushState(
            { searchParams: e },
            "",
            "" + window.location.pathname + (e && "?".concat(e)),
        );
    }
    static getSections() {
        return [{ section: document.getElementById("product-grid").dataset.id }];
    }
    createSearchParams(e) {
        e = new FormData(e);
        return new URLSearchParams(e).toString();
    }
    onSubmitForm(e, t) {
        FacetFiltersForm.renderPage(e, t);
    }
    onSubmitHandler(e) {
        e.preventDefault();
        var r = document.querySelectorAll("facet-filters-form form");
        if ("mobile-facets__checkbox" == e.srcElement.className) {
            var t = this.createSearchParams(e.target.closest("form"));
            this.onSubmitForm(t, e);
        } else {
            let t = [];
            (r.forEach((e) => {
                ("FacetSortForm" !== e.id &&
                    "FacetFiltersForm" !== e.id &&
                    "FacetSortDrawerForm" !== e.id &&
                    "FacetFiltersFormMobile" !== e.id) ||
                    (document.querySelectorAll(".no-js-list").forEach((e) => e.remove()),
                        t.push(this.createSearchParams(e)));
            }),
                this.onSubmitForm(t.join("&"), e));
        }
    }
    onActiveFilterClick(e) {
        (e.preventDefault(), FacetFiltersForm.toggleActiveFacets());
        e =
            -1 == e.currentTarget.href.indexOf("?")
                ? ""
                : e.currentTarget.href.slice(e.currentTarget.href.indexOf("?") + 1);
        FacetFiltersForm.renderPage(e);
    }
}
((FacetFiltersForm.filterData = []),
    (FacetFiltersForm.searchParamsInitial = window.location.search.slice(1)),
    (FacetFiltersForm.searchParamsPrev = window.location.search.slice(1)),
    customElements.define("facet-filters-form", FacetFiltersForm),
    FacetFiltersForm.setListeners());
class PriceRange extends HTMLElement {
    constructor() {
        (super(),
            this.querySelectorAll("input").forEach((e) =>
                e.addEventListener("change", this.onRangeChange.bind(this)),
            ),
            this.setMinAndMaxValues(),
            this.controlSlider(),
            this.controlInput());
    }
    onRangeChange(e) {
        (this.adjustToValidValues(e.currentTarget), this.setMinAndMaxValues());
    }
    setMinAndMaxValues() {
        var e = this.querySelectorAll(".field__input"),
            t = e[0],
            e = e[1];
        (e.value && t.setAttribute("max", e.value),
            t.value && e.setAttribute("min", t.value),
            "" === t.value && e.setAttribute("min", 0),
            "" === e.value && t.setAttribute("max", e.getAttribute("max")));
    }
    adjustToValidValues(e) {
        var t = Number(e.value),
            r = Number(e.getAttribute("min")),
            a = Number(e.getAttribute("max"));
        (t < r && (e.value = r), a < t && (e.value = a));
    }
    fillSlider() {
        document.querySelectorAll(".facets__price .facets__range").forEach((e) => {
            var t = e.querySelectorAll(".field__range"),
                r = t[0],
                t = t[1],
                a = Number(t.max) - Number(t.min),
                r = Number(r.value) - Number(t.min),
                t = Number(t.value) - Number(t.min);
            e.setAttribute(
                "style",
                `--range-min: ${(r / a) * 100}%; --range-max: ${(t / a) * 100}%`,
            );
        });
    }
    controlSlider() {
        var e = document.querySelectorAll(".facets__price .facets__range");
        let s = document.querySelectorAll(".facets__price .facets__price-wrapper");
        e.forEach((e, t) => {
            e = e.querySelectorAll(".field__range");
            let r = e[0],
                a = e[1],
                c = s[t].querySelectorAll(".field__input")[0],
                l = s[t].querySelectorAll(".field__input")[1];
            ((r.oninput = () => {
                var e = Number(r.value),
                    t = Number(a.value);
                (t < e ? ((r.value = t), (c.value = t)) : (c.value = e),
                    this.fillSlider());
            }),
                Number(a.value) <= 0 ? (a.style.zIndex = 2) : (a.style.zIndex = 0),
                (a.oninput = () => {
                    var e = Number(r.value),
                        t = Number(a.value);
                    (e <= t
                        ? ((a.value = t), (l.value = t))
                        : ((l.value = e), (a.value = e)),
                        Number(a.value) <= 0 ? (a.style.zIndex = 2) : (a.style.zIndex = 0),
                        this.fillSlider());
                }));
        });
    }
    controlInput() {
        let s = document.querySelectorAll(".facets__price .facets__range");
        document
            .querySelectorAll(".facets__price .facets__price-wrapper")
            .forEach((e, t) => {
                e = e.querySelectorAll(".field__input");
                let r = e[0],
                    a = e[1],
                    c = s[t].querySelectorAll(".field__range")[0],
                    l = s[t].querySelectorAll(".field__range")[1];
                ((r.oninput = () => {
                    var e = Number(r.value),
                        t = Number(a.value);
                    ((c.value = t && t < e ? t : e), this.fillSlider());
                }),
                    (a.oninput = () => {
                        var e = Number(r.value),
                            t = Number(a.value);
                        ((l.value = e <= t ? t : e), this.fillSlider());
                    }),
                    (r.onblur = () => {
                        var e = Number(r.value),
                            t = Number(r.getAttribute("min"));
                        Number(r.getAttribute("max"));
                        (e < t ? ((c.value = t), (r.value = t)) : (c.value = e),
                            this.fillSlider());
                    }),
                    (a.onblur = () => {
                        var e = Number(a.value),
                            t =
                                (Number(a.getAttribute("min")), Number(a.getAttribute("max")));
                        (t < e ? ((l.value = t), (a.value = t)) : (l.value = e),
                            this.fillSlider());
                    }));
            });
    }
}
customElements.define("price-range", PriceRange);
class FacetRemove extends HTMLElement {
    constructor() {
        super();
        var e = this.querySelector("a");
        (e.setAttribute("role", "button"),
            e.addEventListener("click", this.closeFilter.bind(this)),
            e.addEventListener("keyup", (e) => {
                (e.preventDefault(),
                    "SPACE" === e.code.toUpperCase() && this.closeFilter(e));
            }));
    }
    closeFilter(e) {
        (e.preventDefault(),
            (
                this.closest("facet-filters-form") ||
                document.querySelector("facet-filters-form")
            ).onActiveFilterClick(e));
    }
}
customElements.define("facet-remove", FacetRemove);
